define( 'modules/tester/InternetSpeed',['require','exports','module'],function(require, exports, module) {"use strict";

	// For IE8 and earlier version.
	if (!Date.now) {
		Date.now = function() {
			return new Date().valueOf();
		};
	}

	var urlImg;
	var startTime = Date.now();

	var endTime, duration, downloadSize, bitsLoaded, speedBps, speedKbps, speedMbps;

	var InternetSpeed = {

		Check: function(i, callback) {
			var self = this;
			urlImg = i;

			var url = urlImg + "?r=" + Math.random(999999);
			url=url.replace('http://images2.gazzettaobjects.it',"");
			
			//console.log(url);	

			var XHRObj = $.ajax({
				type : 'HEAD',
				cache : false,
				url : url,
				error : function(a,b,c) {
					
					//console.log(a,b,c);	
					
				},
				success : function(data) {
					endTime = Date.now();
					duration = (endTime - startTime ) / 1000;
					
					
					
					

					if (endTime - startTime === 0) {
						speedMbps = self.getCookie("ispeed");
					} else {
						downloadSize = Number(XHRObj.getResponseHeader('Content-Length'));

						bitsLoaded = Number(downloadSize * 8);

						speedBps = Number(bitsLoaded / duration);
						speedKbps = Number(speedBps / 1024);
						speedMbps = Number(speedKbps / 1024);
						self.setCookie("ispeed", speedMbps, 365);
					}

					callback(speedMbps);
				}
			});
		},

		setCookie: function(cname, cvalue, exdays) {
			var d = new Date();
			d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
			var expires = "expires=" + d.toGMTString();
			document.cookie = cname + "=" + cvalue + "; " + expires;
		},

		getCookie: function(cname) {
			var name = cname + "=";
			var ca = document.cookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i].trim();
				if (c.indexOf(name) === 0)
					return c.substring(name.length, c.length);
			}
			return "";
		}
		
	};

	module.exports = InternetSpeed;

});

